export const ALL_HOURS = "ALL_HOURS";
export const WEEKEND = "WEEKEND";
export const FROM_7AM_TO_2PM = 'FROM_7AM_TO_2PM';
export const FROM_2PM_TO_6PM = 'FROM_2PM_TO_6PM';
export const FROM_6PM_TO_11PM = 'FROM_6PM_TO_11PM';
export const FROM_11PM_TO_7AM = 'FROM_11PM_TO_7AM';
export const FROM_7AM_TO_11PM = 'FROM_7AM_TO_11PM';








